<script setup="">
import { ref, computed, onMounted, nextTick } from 'vue'
import AppModal from "@/components/ui/AppModal.vue";

const isNetworkModal = ref(false)

const checkDate = () => {
  const now = new Date();
  const lsNetworkModal = localStorage.getItem('networkModal')
  if (!lsNetworkModal) {
    openNetworkModal(now)
    return
  }

  const lastView = new Date(lsNetworkModal);
  const isNewDay = now.toDateString() !== lastView.toDateString();

  const eightHours = 8 * 60 * 60 * 1000;
  const isEightHoursPassed = (now - lastView) >= eightHours;

  if (isNewDay && isEightHoursPassed) {
    openNetworkModal(now);
  }
}

const openNetworkModal = (now) => {
  setTimeout(() => {
    isNetworkModal.value = true
    localStorage.setItem('networkModal', now.toISOString())
  }, 30000)
}


const links = [
  {
    icon: 'telegram',
    link: 'https://t.me/reshenie_an',
    title: 'Telegram',
  },
  {
    icon: 'max',
    link: 'https://max.ru/id7811802590_biz',
    title: 'Max',
  },
  {
    icon: 'vk',
    link: 'https://vk.com/resheniean_ru',
    title: 'VK',
  }
]
onMounted( async () => {
  await nextTick()
  checkDate()
})
</script>
<template>
  <AppModal v-model="isNetworkModal">
    <div class="call-request-modal">
      <h3 class="call-request-modal__title">Хотите быть в курсе<br>выгодных предложений?</h3>
      <div class="network-modal-content">
        <p>Подпишитесь на наши соцсети — мы там, где вам удобно!</p>
        <div class="network-modal-actions">
          <a v-for="a in links" class="network-modal-link" :href="a.link" target="_blank" :title="`Подписаться на ${a.title}!`">
            <app-svg :id="a.icon"  class="network-modal-icon" />
          </a>
        </div>
        <ul>
          <li>Реальные кейсы с расчетами и цифрами</li>
          <li>Свежие новости рынка недвижимости</li>
          <li>Консультации в режиме онлайн</li>
        </ul>

      </div>

    </div>
  </AppModal>
</template>
<style lang="scss" scoped>
.call-request-modal {
  $that: &;

  padding: 68px 104px;

  @include tablet {
    padding: 58px;
  }

  @include phone {
    padding: 38px 28px;
  }

  @include phone {
    padding: 28px 16px;
  }

  &__title {
    font-size: 36px;
    line-height: 42px;
    margin-bottom: 42px;
    max-width: 430px;
    color: $color_orange-50;

    @include phone {
      font-size: 24px;
      line-height: 120%;
      margin-bottom: 30px;
    }
  }
}

.network-modal {
  &-content {
    display: flex;
    flex-direction: column;
    gap: 24px;

    ul {
      list-style-type: disc;
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }
  &-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
  }
  &-link, &-icon {
    width: 56px;
    height: 56px;
  }
  &-link:hover {
    color: $color_orange-50;
  }
}

</style>